import { useEffect } from 'react';
import { useApp } from '../app-context';
import { dismissRecovered, noteResponse, useMaintenance } from '../api/maintenance';

/** メンテナンス中の間、Panel が戻ったかを確かめる間隔 */
const PING_MS = 5000;

/** Panel の更新・再起動中に画面の上に出す。戻ったら新しい版を読むための再読み込みを勧める */
export function MaintenanceBanner() {
  const state = useMaintenance();
  const { me, loadMe } = useApp();

  // メンテナンス中に開いて利用者を読めていなければ、戻ったときに読み直す
  useEffect(() => {
    if (state === 'recovered' && !me) void loadMe();
  }, [state, me, loadMe]);

  useEffect(() => {
    if (state !== 'active') return;
    const timer = setInterval(() => {
      void fetch('/api/v1/health', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(
        (response) => noteResponse(response),
        () => undefined, // 回線が切れているなどで届かないときは、そのまま待つ
      );
    }, PING_MS);
    return () => clearInterval(timer);
  }, [state]);

  if (state === 'idle') return null;
  if (state === 'active')
    return (
      <div className="maintenance-banner" role="status" aria-live="polite">
        <strong>ただいまメンテナンス中です。</strong>
        <span>
          パネルを更新・再起動しているため、一時的につながりません。戻るまで自動で確かめ続けます（ふだんは数分）。
        </span>
      </div>
    );
  return (
    <div className="maintenance-banner recovered" role="status" aria-live="polite">
      <strong>メンテナンスが終わりました。</strong>
      <span>新しい版を使うため、ページを読み込み直してください。</span>
      <span className="maintenance-actions">
        <button type="button" className="btn small" onClick={() => location.reload()}>
          読み込み直す
        </button>
        <button type="button" className="btn ghost small" onClick={dismissRecovered}>
          あとで
        </button>
      </span>
    </div>
  );
}
